import React, { PropsWithChildren, ReactElement } from "react";
import { Drawer } from "vaul";
import styles from "./actionSheet.module.scss";

export const ActionSheet = (props: PropsWithChildren<Props>): ReactElement => {
  const PortalComponent = props.withPortal ? Drawer.Portal : React.Fragment;

  return (
    <Drawer.Root>
      <Drawer.Trigger asChild>{props.trigger}</Drawer.Trigger>
      <PortalComponent>
        <Drawer.Overlay className={styles.overlay} />
        <Drawer.Content
          className={styles.content}
          style={{ height: props.height }}
        >
          <Drawer.Handle />

          <div className={styles.scrollable}>{props.children}</div>
        </Drawer.Content>
      </PortalComponent>
    </Drawer.Root>
  );
};

interface Props {
  trigger: JSX.Element;
  withPortal?: boolean;
  height?: number;
}
